import script from "./AppButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppButton.vue?vue&type=script&lang=ts&setup=true"

import "./AppButton.vue?vue&type=style&index=0&id=2be59f8c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2be59f8c"]])

export default __exports__